enum CmInterceptHeaderType {
	IgnoreAuthError = 'CM-ignore-error',
	BypassAuth = 'X-bypass-token',
	SuppressError = 'ichabod-suppress-error',
	SuppressErrorLog = 'ichabod-suppress-error-log',
	ClientHeader = 'CM-Client',
	BypassLoadIndicator = 'ATS-bypass-load-indicator',
	SuppressErrorById = 'ichabod-suppress-error-by-id',
}

export class CmInterceptHeaders {
	public static Type = CmInterceptHeaderType;
	public static IgnoreAuthError = { [CmInterceptHeaderType.IgnoreAuthError]: 'true' };
	public static BypassAuth = { [CmInterceptHeaderType.BypassAuth]: 'true' };
	public static SuppressError = { [CmInterceptHeaderType.SuppressError]: 'true' };
	public static SuppressErrorLog = { [CmInterceptHeaderType.SuppressErrorLog]: 'true' };
	public static BypassLoadIndicator = { [CmInterceptHeaderType.BypassLoadIndicator]: 'true' };
	public static ClientHeader = (client: string) => ({
		[CmInterceptHeaderType.ClientHeader]: client,
	});
	public static SuppressErrorById = (guid: string) => ({
		[CmInterceptHeaderType.SuppressErrorById]: guid,
	});
}
